import { SpreadsheetExportType } from '../enums/spreadsheet-export-type.enum';

// The five list exports are a family inside SpreadsheetExportType, not the whole enum, so the
// lookup is narrowed to them: adding one here without its label breaks the build, which is the
// point of the Record.
export const DOCUMENT_LIST_SPREADSHEET_EXPORT_TYPES = [
  SpreadsheetExportType.CreditList,
  SpreadsheetExportType.InvoiceList,
  SpreadsheetExportType.MiscellaneousOperationList,
  SpreadsheetExportType.PaymentList,
  SpreadsheetExportType.ProFormaList,
] as const;

export type DocumentListSpreadsheetExportType = (typeof DOCUMENT_LIST_SPREADSHEET_EXPORT_TYPES)[number];

export class DocumentListSpreadsheetExportTypeHelper {
  private static readonly LABELS: Record<DocumentListSpreadsheetExportType, string> = {
    [SpreadsheetExportType.CreditList]: "PDF de la liste des factures d'avoir",
    [SpreadsheetExportType.InvoiceList]: 'PDF de la liste des factures',
    [SpreadsheetExportType.MiscellaneousOperationList]: 'PDF de la liste des OD',
    [SpreadsheetExportType.PaymentList]: 'PDF de la liste des règlements',
    [SpreadsheetExportType.ProFormaList]: 'PDF de la liste des pro formas',
  };

  public static isDocumentList(enumValue: SpreadsheetExportType): enumValue is DocumentListSpreadsheetExportType {
    return (DOCUMENT_LIST_SPREADSHEET_EXPORT_TYPES as readonly SpreadsheetExportType[]).includes(enumValue);
  }

  public static toGenerationMessage(enumValue: DocumentListSpreadsheetExportType): string {
    return `${this.translateEnum(enumValue)} en cours de génération`;
  }

  public static translateEnum(enumValue: DocumentListSpreadsheetExportType): string {
    return this.LABELS[enumValue];
  }
}
